import settings from './settings/settings.routes';
import conversation from './conversation/conversation.routes';
import { routes as searchRoutes } from '../../modules/search/search.routes';
import { routes as contactRoutes } from './contacts/routes';
import { routes as companyRoutes } from './companies/routes';
import { routes as flipLeadsRoutes } from './flipLeads/routes';
import { routes as franchiseRoutes } from './franchises/routes';
import { routes as internalChatRoutes } from './internalChat/routes';
import { routes as notificationRoutes } from './notifications/routes';
import { routes as inboxRoutes } from './inbox/routes';
import { routes as kanbanRoutes } from './kanban/routes';
import { frontendURL } from '../../helper/URLHelper';
import helpcenterRoutes from './helpcenter/helpcenter.routes';
import automations from './automations/automations.routes';
import { routes as myTasksRoutes } from './my_tasks/routes';
import onboarding from './onboarding/onboarding.routes';

const AppContainer = () => import('./Dashboard.vue');
const Suspended = () => import('./suspended/Index.vue');

export default {
  routes: [
    ...helpcenterRoutes.routes,
    {
      path: frontendURL('accounts/:account_id'),
      component: AppContainer,
      children: [
        ...inboxRoutes,
        ...conversation.routes,
        ...settings.routes,
        ...automations.routes,
        ...contactRoutes,
        ...companyRoutes,
        ...flipLeadsRoutes,
        ...franchiseRoutes,
        ...searchRoutes,
        ...notificationRoutes,
        ...kanbanRoutes,
        ...myTasksRoutes,
        ...internalChatRoutes,
        ...onboarding.routes,
      ],
    },
    {
      path: frontendURL('accounts/:accountId/suspended'),
      name: 'account_suspended',
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      component: Suspended,
    },
  ],
};
